<template>
  <div class="step1">

    <div class="step-header">
      <h3>Konfirmasi Pelanggaran</h3>
      <p class="instruction-text">
        Masukkan <b>Nomor Registrasi</b> dan <b>Nomor TNKB</b> sesuai surat konfirmasi yang Anda terima.
      </p>
    </div>

    <form @submit.prevent="detailsPelanggaran">

      <div class="input-card">

        <div class="field-row">

          <div class="field">
            <label for="noRef">Nomor Registrasi</label>
            <div class="input-box">
              <i class="bi bi-file-earmark-text"></i>
              <input id="noRef" type="text" v-model="noReferensi" placeholder="Masukan Nomor Registrasi"
                class="modern-input" />
            </div>
          </div>

          <div class="field">
            <label for="noPlat">Nomor TNKB</label>
            <div class="input-box">
              <i class="bi bi-truck"></i>
              <input id="noPlat" type="text" v-model="noPolisi" placeholder="Masukan Nomor TNKB" class="modern-input" />
            </div>
          </div>
          <!-- <CaptchaInput ref="captcha" v-model="captcha" :token.sync="captchaToken" :url="captchaUrl" /> -->
        </div>

      </div>

      <div class="button-group">
        <button type="submit" class="btn-search" :disabled="isLoading">
          <template v-if="isLoading">
            Mencari Data... <i class="bi bi-hourglass-split"></i>
          </template>
          <template v-else>
            Cari Data Pelanggaran
            <i class="bi bi-arrow-right"></i>
          </template>
        </button>
      </div>

    </form>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import { postDetailsKonfirmasi } from "./api.js";
import { getCekPembayaran } from "../CekPelanggaran/api.js";
import logoKemenhub from "../../assets/image/kemenhub.png";
import CaptchaInput from "./CaptchaInput.vue";

export default {
  data() {
    return {
      logoKemenhub,
      noReferensi: "",
      noPolisi: "",
      isLoading: false,
      captcha: "",
      captchaToken: "",
      captchaUrl: process.env.VUE_APP_API_URL + "/etle/api/captcha_api.php",
    };
  },
  computed: {
    noPolisiClean() {
      return this.noPolisi.replace(/\s+/g, '').toUpperCase();
    }
  },
  mounted() {
    const q = this.$route.query;
    const ref  = q.ref_number || q['nomor-registrasi'];
    const plat = q.plates || q.tnkb;
    if (ref)  this.noReferensi = String(ref).trim();
    if (plat) this.noPolisi = String(plat).trim().toUpperCase();
  },
  methods: {
    async detailsPelanggaran() {
      if (this.isLoading) return;
      if (!this.validateInput()) return;
      this.isLoading = true;
      try {
        const response = await this.fetchPelanggaranData();
        if (
          response.data?.status === false &&
          response.data?.message?.includes("Daya Angkut")
        ) {
          await Swal.fire({
            title: "Peringatan Daya Angkut",
            text: "Terhadap Pelanggaran Daya Angkut diberikan sanksi PERINGATAN untuk segera melakukan penyesuaian daya angkut sesuai dengan jumlah berat muatan. Terhitung mulai tanggal 1 Januari 2027 terhadap pelanggaran Daya Angkut.",
            icon: "warning",
            confirmButtonText: "OK",
          });
          return;
        }
        await this.handlePelanggaranResponse(response);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
        // this.$refs.captcha?.refresh();
      }
    },
    validateInput() {
      if (!this.noReferensi || !this.noPolisi) {
        Swal.fire({ title: "Data tidak lengkap!", text: "Mohon masukkan No Registrasi dan No TNKB.", icon: "warning" });
        return false;
      }
      // if (!this.captcha || this.captcha.length < 5) {
      //   Swal.fire({ title: "Captcha belum diisi", text: "Ketik 5 karakter kode pada gambar.", icon: "warning" });
      //   return false;
      // }
      // if (!this.captchaToken) {
      //   Swal.fire({ title: "Captcha belum siap", text: "Klik tombol refresh pada captcha lalu coba lagi.", icon: "warning" });
      //   return false;
      // }
      return true;
    },
    async fetchPelanggaranData() {
      const formData = new FormData();
      // formData.append("captcha", this.captcha);
      // formData.append("captcha_token", this.captchaToken);
      formData.append("no_ref", this.noReferensi);
      formData.append("no_plat", this.noPolisiClean);
      return await postDetailsKonfirmasi(formData);
    },
    async handlePelanggaranResponse(response, refNumber, plates) {
      if (
        !response.data ||
        (Array.isArray(response.data) && response.data.length === 0)
      ) {
        await Swal.fire({
          title: "Data Tidak Ditemukan",
          text: "Nomor Registrasi atau Nomor TNKB yang Anda masukkan tidak sesuai.",
          icon: "error",
          confirmButtonText: "OK",
        });

        return;
      }

      if (response.data.status === false) {
        await Swal.fire({
          title: "Data Tidak Valid",
          text: response.data.message || "Data yang Anda masukkan tidak sesuai.",
          icon: "error",
          confirmButtonText: "OK",
        });

        return;
      }

      if(response.data[0].status_pelanggaran === "99") {
        await Swal.fire({
          title: "Pelanggaran Dihentikan",
          text: "Pelanggaran ini telah dihentikan dan tidak dapat diproses.",
          icon: "info",
          confirmButtonText: "OK",
        });

        return;
      }

      const noRef = refNumber || this.noReferensi;
      const noPlat = plates
        ? plates.replace(/\s+/g, "").toUpperCase()
        : this.noPolisiClean;

      let pembayaran = null;

      try {
        pembayaran = await getCekPembayaran(noRef, noPlat);
        console.log("Response pembayaran:", pembayaran);
      } catch (err) {
        console.warn("Gagal cek pembayaran:", err);
      }

      if (
        !pembayaran ||
        !pembayaran.data ||
        pembayaran.data.status === false ||
        !pembayaran.data.data
      ) {
        await Swal.fire({
          title: "Data Ditemukan",
          text: "Silakan lanjutkan proses konfirmasi.",
          icon: "success",
          confirmButtonText: "OK",
        });

        this.$emit("next", {
          noReferensi: noRef,
          noPolisi: noPlat,
          pelanggaranData: response.data,
        });

        return;
      }

      const statusPembayaran = String(pembayaran.data.data.status);

      if (statusPembayaran === "30") {
        await Swal.fire({
          title: "Kendaraan Sudah Diblokir",
          text: "Kendaraan ini telah diblokir. Anda tetap dapat melanjutkan proses konfirmasi.",
          icon: "warning",
          confirmButtonText: "Lanjutkan",
        });

        this.$emit("next", {
          noReferensi: noRef,
          noPolisi: noPlat,
          pelanggaranData: response.data,
        });

        return;
      }

      if (["11", "20", "21"].includes(statusPembayaran)) {
        await Swal.fire({
          title: "Detail Pelanggaran Ditemukan",
          text: "Anda akan diarahkan ke halaman Detail Pelanggaran.",
          icon: "success",
          confirmButtonText: "OK",
        });

        this.$router.push({
          name: "Pelanggaran",
          query: {
            ref_number: noRef,
            plates: noPlat,
          },
        });

        return;
      }

      await Swal.fire({
        title: "Data Ditemukan",
        text: "Pelanggaran berhasil ditemukan.",
        icon: "success",
        confirmButtonText: "OK",
      });

      this.$emit("next", {
        noReferensi: noRef,
        noPolisi: noPlat,
        pelanggaranData: response.data,
      });
    },
    handleError(error) {
      Swal.fire({
        title: "Kesalahan!",
        text: "Terjadi kesalahan saat memproses permintaan.",
        icon: "error",
      });
      console.error("Error fetching data:", error);
    },
  },
  components: {
    CaptchaInput,
  },
};
</script>

<style scoped>
.step1 {
  width: 100%;
}

.step-header {
  margin-bottom: 35px;
}

.step-header h3 {
  font-size: 30px;
  font-weight: normal;
  color: #0f2f5f;
  margin-bottom: 12px;
}

.instruction-text {
  color: #2d3748;
  line-height: 1.7;
  font-size: 18px;
  font-weight: normal;
}

.input-card {
  background: #f8fafc;
  border: 2px solid #cbd5e1;
  border-radius: 14px;
  padding: 35px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.field label {
  display: block;
  margin-bottom: 12px;
  font-weight: normal;
  font-size: 18px;
  color: #1a202c;
}

.input-box {
  position: relative;
}

.input-box i {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  color: #005bac;
  font-size: 20px;
}

.modern-input {
  width: 100%;
  height: 62px;
  border-radius: 10px;
  border: 2px solid #b2c2d3;
  padding-left: 54px;
  font-size: 18px;
  color: #000000;
  font-weight: normal;
  transition: 0.2s;
  background: #fff;
}

.modern-input::placeholder {
  color: #718096;
  opacity: 1;
}

.modern-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15);
}

.button-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
}

.btn-search {
  min-width: 280px;
  height: 58px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  font-weight: normal;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-search:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.25);
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

@media (max-width: 768px) {
  .button-group {
    justify-content: center;
  }

  .field-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .btn-search {
    width: 100%;
    height: 60px;
  }

  .step-header h3 {
    font-size: 26px;
  }

  .instruction-text,
  .field label,
  .modern-input,
  .btn-search {
    font-size: 16px;
  }
}
</style>